// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowChevronRightDiagonal = function IconArrowChevronRightDiagonal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"-2 -2 24 24","fill":"none","transform":"scale(1.25)"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M10 15.5V8.5H3V7H11.5V15.5H10ZM14 11.5V4.5H7V3H15.5V11.5H14Z"}}]}]})(props);
};
